// Labelled range input shared by the cross-sample verbs (Sidechain,
// Stretch, Freeze, Pitch). Layout is row-shaped: label on the left, the
// range fills the middle, a tabular-numbers display column on the right.
//
// MangleVerb has its own narrower InlineSlider — left as-is because its
// layout sits inside per-block rows where space is tighter. If a third
// layout shows up later, consider unifying then.

export type SliderProps = {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  display: string;
  onChange: (n: number) => void;
  /** Display column width. 'narrow' (w-16) for short values like "120 ms";
   *  'wide' (w-32) for long values like "C4 (MIDI 60)". Default 'wide'. */
  displayWidth?: 'narrow' | 'wide';
};

export function Slider({
  label,
  value,
  min,
  max,
  step,
  display,
  onChange,
  displayWidth = 'wide',
}: SliderProps) {
  const widthClass = displayWidth === 'narrow' ? 'w-16' : 'w-32';
  return (
    <label className="flex items-center gap-2 text-[10px] uppercase tracking-[0.18em] text-zinc-500">
      <span className="w-16">{label}</span>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="accent-yellow-300 flex-1"
      />
      <span className={`text-zinc-200 normal-case tabular-nums text-right ${widthClass}`}>
        {display}
      </span>
    </label>
  );
}
